import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context/index";
import jp from "jsonpath";

interface DigitalChannelSettingsProps {
  title: string;
  data: any;
};

export const DigitalChannelSettings: React.FC<DigitalChannelSettingsProps> = ({
  title,
  data
}) => {
  const {
    appState: { infoObjRolesByTenantState: {
      dataRolesByTenantGlobal,
      functionalitiesCodesMap,
    }},
    t,
  } = useContext(AppContext);

  // Obtengo los permisos para la funcionalidad de Formatos e Idiomas
  const formatsAndLangPrivileges = (!!dataRolesByTenantGlobal && !!functionalitiesCodesMap)
    && jp.query(dataRolesByTenantGlobal, `$..[?(@.functionalityId=="${functionalitiesCodesMap['/configurations/initialbankInfo']}")].permission.privilegeId`);

  const navigate = useNavigate();

  return (
    <div className="digital-channel-container">
      <div className="title">
        {title}
      </div>
      <div className="card-container">
        {data.map((item: any) => (
          (item.value !== "Ir a Formatos e idiomas" || (item.value === "Ir a Formatos e idiomas" && !!formatsAndLangPrivileges && formatsAndLangPrivileges?.includes('READ')))
          ? <div className="card-content" onClick={() => navigate(item.value === "Ir a Formatos e idiomas" ? "/configurations/initialbankInfo" : "/")}>
              {item.iconname 
                ?
                  <div className="card-iconname">
                    <i className={item.iconname} id="iconname-icon" />
                  </div>
                :
                  <div className="card-title">
                    {item.name}
                  </div>
              }
              <div className="card-value">
                {(item.value === "en" || item.value === "es") ? item.value === "en" ? t("Languages.en") : t("Languages.es") : item.value !== null ? item.value : '-' }
              </div>
            </div>
          : null
        ))}
      </div>
    </div>
  );
};
